import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';

type SystemStatusesProps = {
  facility: Facility;
};

const SystemStatuses: React.FC<SystemStatusesProps> = (props) => {
  const { facility } = props;

  const allCommunicationsDisabledAlert = (
    <><br/><i className="fa-solid fa-triangle-exclamation" /> <em>all communications disabled</em></>
  );

  return (
    <Card>
      <Card.Header>System Statuses</Card.Header>
      <Card.Body>
        <Alert variant={facility.communicationsEnabled ? 'success' : 'danger'}>All Communications</Alert>
        <Alert variant={facility.featureTexting && facility.communicationsEnabled ? 'success' : 'danger'} style={{ marginLeft: 15 }}>
          Texting
          {!facility.communicationsEnabled && allCommunicationsDisabledAlert}
        </Alert>
        <Alert variant={facility.textingLocalStatus && facility.communicationsEnabled ? 'success' : 'danger'} style={{ marginLeft: 15 }}>
          Texting Facility Status
          {!facility.communicationsEnabled && allCommunicationsDisabledAlert}
        </Alert>
        <Alert variant={facility.audioCallingEnabled && facility.communicationsEnabled ? 'success' : 'danger'} style={{ marginLeft: 15 }}>
          Audio Calling
          {!facility.communicationsEnabled && allCommunicationsDisabledAlert}
        </Alert>
        <Alert variant={facility.videoCallingEnabled && facility.communicationsEnabled ? 'success' : 'danger'} style={{ marginLeft: 15 }}>
          Video Calling
          {!facility.communicationsEnabled && allCommunicationsDisabledAlert}
        </Alert>
        <Alert variant={facility.featureCommissaryTransfer ? 'success' : 'danger'}>
          Purchase Feature
        </Alert>
      </Card.Body>
    </Card>
  );
};

export default SystemStatuses;
